import Cookies from "js-cookie";
import {
  GET_PERSONAS_URL,
  DELETE_PERSONA_URL,
  CREATE_PERSONA_URL,
  UPDATE_PERSONA_URL,
  GET_PERSONA_URL,
} from "../apiurls/apiurls";

const getAuthToken = () => {
  return Cookies.get("admin_token");
};

const getHeaders = () => {
  const headers = { "Content-Type": "application/json" };
  const token = getAuthToken();
  if (token) {
    headers["Authorization"] = ` ${token}`;
  }
  return headers;
};

export const getPersonas = async (type) => {
  const params = new URLSearchParams();
  if (type) {
    params.append("persona_type", type);
  }

  const url = params.toString()
    ? `${GET_PERSONAS_URL}?${params.toString()}`
    : GET_PERSONAS_URL;

  const response = await fetch(url, {
    method: "GET",
    headers: getHeaders(),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = await response.json();
  if (data && Array.isArray(data.data)) return data.data;
  return Array.isArray(data) ? data : data ? [data] : [];
};

export const getPersonaById = async (id) => {
  if (!id) {
    throw new Error("Persona id is required");
  }

  const params = new URLSearchParams();
  params.append("id", id);

  const response = await fetch(`${GET_PERSONA_URL}?${params.toString()}`, {
    method: "GET",
    headers: getHeaders(),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = await response.json();
  return data;
};

export const deletePersona = async (id) => {
  if (!id) {
    throw new Error("Persona id is required for delete");
  }

  const params = new URLSearchParams();
  params.append("id", id);

  const response = await fetch(`${DELETE_PERSONA_URL}?${params.toString()}`, {
    method: "DELETE",
    headers: getHeaders(),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};

export const updatePersona = async (id, payload) => {
  if (!id) {
    throw new Error("Persona id is required for update");
  }

  const params = new URLSearchParams();
  params.append("id", id);

  const response = await fetch(`${UPDATE_PERSONA_URL}?${params.toString()}`, {
    method: "PUT",
    headers: getHeaders(),
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};

export const createPersona = async (payload) => {
  const response = await fetch(CREATE_PERSONA_URL, {
    method: "POST",
    headers: getHeaders(),
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};
